import React, {useRef, useState} from 'react';
import {DatePicker, Input, Space, Button, Select, Typography} from 'antd';

import {PageGrid} from '@/component';
import {getColumns} from './taskResultColumns';
import {FileOutlined} from '@/icons';
import {getEndTimestamp, getStartTimestamp} from '@/util/dateUtils';
import TaskResultInfoModal from '@/page/admin/JobsPage/TaskResultPage/TaskResultInfoModal';

const {Option} = Select;
export default function TaskResultList() {
    const tableRef = useRef();
    const taskResultInfoModalRef = useRef();

    const [taskName, setTaskName] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status, setStatus] = useState(null);

    function onStatusChange(value) {
        setStatus(value);
    }

    //查看详情
    function onViewClick(record) {
        taskResultInfoModalRef.current.showModal(record.id);
    }

    function onTaskNameChange({target: {value}}) {
        setTaskName(value);
    }

    function onStartDateChange(date) {
        setStartDate(date);
    }

    function onEndDateChange(date) {
        setEndDate(date);
    }

    function onSubmit() {
        const begin = startDate && getStartTimestamp(startDate);
        const end = endDate && getEndTimestamp(endDate);
        const params = {
            taskName: taskName,
            begin: begin,
            end: end,
            status: status,
        };
        tableRef.current.reload2FirstPage(params);
    }

    function onReset() {
        setTaskName(null);
        setEndDate(null);
        setStartDate(null);
        setStatus(null);
        tableRef.current.reload2FirstPage({});
    }

    const columns = getColumns(['id', 'taskName', 'ip', 'status', 'execTime', 'taskResult']);
    columns.push({
        title: '操作',
        key: 'action',
        width: 100,
        render: (text, record) => (
            <Button type="link" icon={<FileOutlined />} onClick={() => onViewClick(record)}>
                查看详细
            </Button>
        ),
    });

    function renderExtra() {
        return (
            <Space>
                <Input placeholder="任务名称" value={taskName} onChange={onTaskNameChange} />
                <Select value={status} style={{width: 120}} onChange={onStatusChange}>
                    <Option value={null}>状态</Option>
                    <Option value="0">正常</Option>
                    <Option value="1">异常</Option>
                </Select>
                <DatePicker placeholder="起始时间" value={startDate} onChange={onStartDateChange} />
                <DatePicker placeholder="截止时间" value={endDate} onChange={onEndDateChange} />
                <Button type="primary" onClick={onSubmit}>
                    搜索
                </Button>
                <Button onClick={onReset}>重置</Button>
                <Button type="primary" onClick={onSubmit}>
                    刷新
                </Button>
            </Space>
        );
    }

    return (
        <div style={{flex: 'auto', flexDirection: 'row'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
                <Typography.Title level={3}>执行结果列表</Typography.Title>
                <div>
                    {renderExtra()}
                </div>
            </div>
            <div style={{margin: '0 24px 24px'}}>
                <PageGrid ref={tableRef} url={'/taskHistories'} columns={columns} />
            </div>
            <TaskResultInfoModal ref={taskResultInfoModalRef} modalTitle="执行结果" />
        </div>
    );
}
